<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Slide Preview"
      id="admin_delete_slidedetails"
    >
        <v-btn @click="$router.go(-1)" small rounded outlined color="default">
        <v-icon left>mdi-stop</v-icon> Cancel Delete
      </v-btn>
    </CardedSectionHeader>
    <Slider :items="items" ></Slider>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete Slider Concent Form "
      id="admin_delete_slider_form"
    ></CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="slider_delete_form_ref"
      id="slider_delete_form"
      message="<b>Delete was succesfull</b> <br/> Slider has been removed"
      :is_loading="is_loading"
      :seed="{slider:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import Slider from "../../../components/Slider";
import DeleteConcentForm from "../../../components/DeleteConcentForm";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminSlidersDelete",
  components: {
    CardedSectionHeader,
    DeleteConcentForm,
    Slider
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      slider: Utils.get_default_slider(),
      errors: [],
      message: "",
      items: [],
      not_found: false
    };
  },
  methods: {
    on_success() {
      //go back to sliders list
      this.$router.push("/admin/sliders/list");
    },
    load_slider() {
      this.$emit("on-show-loader");
      ServerClient.Sliders.get_slider(
        {
          id: this.$route.params.id
        },
        (res) => {
          this.$emit("on-hide-loader");
          console.log("slider to be deleted ", res);
          if (res == null) {
            this.not_found = true;
          } else {
            this.items = [res];
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading slider details on admin delete slider ",
            errors
          );
        }
      );
    },
  },
  mounted() {
    var slider_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Delete Slider",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Sliders",
          disabled: false,
          href: "/admin/sliders",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/sliders/list",
        },
        {
          text: "Delete",
          disabled: false,
          href: "/admin/sliders/list/delete/" + slider_id,
        }
      ],
      navbar_cols: 3,
    });
    this.load_slider();
  },
};
</script>